import { FormattedMessage } from 'react-intl';

export const CONTROL_CYCLE_OPTIONS = {
	7: <FormattedMessage id={'control-cycle.weekly'} />,
	14: <FormattedMessage id={'control-cycle.biweekly'} />,
	30: <FormattedMessage id={'control-cycle.monthly'} />,
	90: <FormattedMessage id={'control-cycle.quarterly'} />,
	365: <FormattedMessage id={'control-cycle.annualy'} />,
};
